
import { canSendAnalytics, pageLocationForAnalytics } from '@/lib/analytics';

// Older engagement events. They share the production-host gate with conversions
// so a stray gtag on localhost or a preview cannot send pageviews or events.
function pagePathForAnalytics(pageLocation: string): string {
  const url = new URL(pageLocation);
  return `${url.pathname}${url.search}`;
}

export const trackEvent = (eventName: string, parameters?: Record<string, unknown>) => {
  if (!canSendAnalytics()) return;
  try {
    window.gtag!('event', eventName, parameters);
  } catch {
    // A broken tag must not break the page.
  }
};

export const trackPageView = (pagePath: string, pageTitle?: string) => {
  if (!canSendAnalytics()) return;
  const absolute = /^https?:\/\//i.test(pagePath)
    ? pagePath
    : `${window.location.origin}${pagePath.startsWith('/') ? pagePath : `/${pagePath}`}`;
  try {
    const pageLocation = pageLocationForAnalytics(absolute);
    window.gtag!('config', 'G-PDEHHK9F0X', {
      page_path: pagePathForAnalytics(pageLocation),
      page_title: pageTitle,
      page_location: pageLocation,
    });
  } catch {
    // A broken tag must not break the page.
  }
};

export const trackMilkyWayPlanCreated = (location: string, month: number, year: number) => {
  trackEvent('milky_way_plan_created', {
    event_category: 'engagement',
    event_label: location,
    custom_parameter_month: month,
    custom_parameter_year: year,
    custom_parameter_location: location,
  });
};

export const trackExportDownload = (format: string, location: string) => {
  trackEvent('export_download', {
    event_category: 'engagement',
    event_label: `${format}_${location}`,
    export_format: format,
    location: location,
  });
};

export const trackAnnualCalendarCreated = (location: string, year: number, userType: string) => {
  trackEvent('annual_calendar_created', {
    event_category: 'lead_generation',
    event_label: location,
    custom_parameter_year: year,
    custom_parameter_user_type: userType,
  });
};

export const trackAnnualCalendarView = (slug: string, location: string) => {
  trackEvent('annual_calendar_view', {
    event_category: 'engagement',
    event_label: slug,
    location: location,
  });
};

export const trackAnnualCalendarDownload = (slug: string, location: string) => {
  trackEvent('annual_calendar_download', {
    event_category: 'engagement',
    event_label: slug,
    location: location,
  });
};
